module.exports = __webpack_public_path__ + "static/media/Yenepoya-Logo-web.148b3af8.png";